module.exports = __webpack_public_path__ + "static/media/MT10.b5fe88d9.mp3";